// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","393":"3f09e426","455":"e290cd7d","486":"01aa603a","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};